import {useSelector} from 'react-redux';

import {ChipState} from 'notebook/mediocre/core-ui/SnapshotChip';
import {EditorPropertiesContext} from 'notebook/notes/core-ui/NoteContext';
import {BenchlingState} from 'redux-stores/reduceApp';
import APIUtil from 'util/APIUtil';

export interface UseEntryChipStateInterface {
  [entryApiId: string]: ChipState;
}

export default function useEntryChipState(): UseEntryChipStateInterface | null {
  const {fileId} = EditorPropertiesContext.useContext();
  return useSelector((state: BenchlingState) => {
    // Currently only entries load the chip state into the export state
    if (!fileId || !APIUtil.isEntry(fileId)) {
      return null;
    }
    return state.ui.export[fileId]?.chips ?? null;
  });
}
